export const UPLOAD_ENTITY_TYPES = {
  FOLDER: "FOLDER",
  DOC_STYLE_TEMPLATES: "DOC_STYLE_TEMPLATES",
  OPPORTUNITY: "OPPORTUNITY",
  PROPOSAL: "PROPOSAL",
  CONTRACT: "CONTRACT",
  MISC_ANALYSIS: "MISC_ANALYSIS",
  MISC_ANALYSIS_RESEARCH: "MISC_ANALYSIS_RESEARCH",
  MISC_ANALYSIS_PROPOSAL_WRITING: "MISC_ANALYSIS_PROPOSAL_WRITING",
  COLLECTIONS: "COLLECTIONS",
};

export const getIsOutlineEntityType = (entityType) =>
  entityType === UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_PROPOSAL_WRITING ||
  entityType === UPLOAD_ENTITY_TYPES.PROPOSAL;

export const COLLECTION_CHUNK_URL = "/rag/upload/chunk";
export const COLLECTION_UPLOAD_URL = "/rag/collection/reindex";

export const DOCUMENT_CHUNK_URL = "/document/queue/upload/chunk";
export const DOCUMENT_UPLOAD_URL = "/document/queue/initialize";

export const STYLE_TEMPLATES_CHUNK_URL =
  "/nextgen/admin/document-templates/upload/chunk";
export const STYLE_TEMPLATES_UPLOAD_URL =
  "/nextgen/admin/document-templates/initialize";
